import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import LacrosseTraining from "./pages/LacrosseTraining";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/lacrosse" element={<LacrosseTraining variant="girls" />} />
          <Route path="/lacrosse/boys" element={<LacrosseTraining variant="boys" />} />
          <Route path="/lacrosse/girls" element={<LacrosseTraining variant="girls" />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
